<template>
  <div>
    <v-container fill-height fluid grid-list-xl class="pl-4 pt-0">
      <v-layout wrap>
        <v-flex>
          <div
            v-if="request && request.id"
            style="position: sticky; top: 0px; z-index: 10;"
          >
            <TicketViewHeader
              :initialData="{ ticket: request, technicianMode: false }"
            />
          </div>

          <v-layout v-if="request && request.id">
            <v-flex d-flex style="width: 700px;">
              <v-card
                style="border: 2px solid rgb(76, 175, 80); border-radius: 12px; width: 100%;"
              >
                <v-layout row align-center class="px-3">
                  <v-card-text>
                    <div
                      class="body-1 font-weight-light d-flex align-center"
                      style="flex-wrap: wrap; justify-content: space-between;"
                    >
                      <div
                        style="flex: 1 1 auto; min-width: 0; margin-right: 8px;"
                      >
                        Requested By:
                        <span class="font-weight-medium">
                          <span>{{ request.requesterName }}</span>
                        </span>

                        On:
                        <span class="font-weight-medium">{{
                          request.createdAt | time
                        }}</span>
                        User:
                        <span class="font-weight-medium">{{ meUsername }}</span>
                        <span v-show="request.requesterEmailID">
                          Email:
                        </span>

                        <span class="font-weight-medium">{{
                          request.requesterEmailID
                        }}</span>

                        Create via:
                        <span class="font-weight-medium"
                          >{{ request.source }}
                          {{
                            request.itReceptionBy
                              ? `: ${request.itReceptionBy}`
                              : ""
                          }}</span
                        >
                      </div>
                      <span class="text-xs-right" style="flex: 0 0 auto;">
                        <v-btn
                          style="border-radius: 6px; padding: 4px 14px; font-size: 13px; font-weight: 700; white-space: nowrap; display: inline-flex; align-items: center; gap: 3px;"
                          small
                          color="error"
                          :disabled="request.statusName === 'Closed'"
                          @click="closeTicketDialog = true"
                        >
                          Close Ticket
                        </v-btn>
                        <v-btn
                          style="border-radius: 6px; padding: 4px 14px; font-size: 13px; font-weight: 700; white-space: nowrap; display: inline-flex; align-items: center; gap: 3px;"
                          small
                          color="success"
                          :title="
                            request.statusName === 'Closed'
                              ? 'Adding a comment will reopen the ticket'
                              : 'Add comment'
                          "
                          @click="replyDialog = true"
                        >
                          Add Comment
                        </v-btn>
                      </span>
                    </div>

                    <HelpDeskConversations
                      ref="conversations"
                      :initialData="{
                        ticket: request,
                        technicianMode: false,
                        oldTicket: oldTicket,
                      }"
                    />
                  </v-card-text>
                </v-layout> </v-card
            ></v-flex>
            <v-flex style="min-width: 450px; max-width: 450px; width: 450px;">
              <TicketDetailsPanel
                :key="request.displayID"
                :initialData="{ ticket: request, technicianMode: false }"
                @updated="loadRequest"
              />
            </v-flex>
          </v-layout>
          <v-layout
            v-else
            align-center
            justify-center
            column
            style="height:300px; gap:16px"
          >
            <v-progress-circular
              indeterminate
              color="primary"
              size="56"
            ></v-progress-circular>
            <span class="subheading grey--text">Loading...</span>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-container>

    <v-dialog v-model="replyDialog" persistent max-width="700">
      <v-card v-if="!oldTicket" style="border: 2px solid green;">
        <v-card-title class="pb-0">
          <span class="headline">Add Comment</span>
          <span class="ml-3" style="color: red"
            >If this is a different topic
            <router-link
              :to="{
                name: 'HelpDeskRequests',
                query: {
                  openNewTicket: true,
                },
              }"
            >
              <span style="color: green">
                click here to open a separate ticket.</span
              >
            </router-link></span
          >
        </v-card-title>
        <v-form ref="form">
          <v-container grid-list-md class="py-1">
            <v-layout wrap>
              <v-flex xs12>
                <v-Textarea
                  rows="10"
                  v-model="replyDescription"
                  label="Write a message"
                  outline
                  ref="reply"
                ></v-Textarea>
              </v-flex>
            </v-layout>
          </v-container>
          <v-flex xs12 sm8 class="ml-3">
            <ManageengineUploadFiles
              v-if="request && request.id"
              ref="uploadFiles"
              :uploadUrl="
                `api/Manageengine/ManageengineUpload?manageengineID=${
                  request.manageengineID
                }&type=notifications`
              "
              :files.sync="fileUploadList"
              :uploading.sync="uploading"
            />
          </v-flex>
          <v-card-actions class="pb-3 pt-0">
            <v-spacer></v-spacer>

            <v-btn color="default" @click="resetReplyDialog" dark small
              >Cancel</v-btn
            >
            <v-btn
              :loading="processing"
              color="success"
              @click="reply"
              small
              :disabled="replyDescription.length === 0 || uploading"
              >Send</v-btn
            >
          </v-card-actions>
        </v-form>
      </v-card>
      <v-card v-else style="border: 2px solid green;">
        <v-card-title class="pb-0">
          <span class="headline">Attention! </span>
        </v-card-title>
        <v-card-text>
          <div class="mt-0 ml-3">
            This ticket has been closed for a long time.
          </div>

          <router-link
            :to="{
              name: 'HelpDeskRequests',
              query: { openNewTicket: true },
            }"
          >
            <div class="green--text ml-3 font-weight-medium">
              Click here to open a new ticket.
            </div>
          </router-link>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="default" @click="resetReplyDialog" dark small
            >Close</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <CloseTicketDialog
      v-if="request && request.id"
      v-model="closeTicketDialog"
      :initial-data="{ request: request, technicianMode: false }"
      @tickedClosed="loadRequest"
    />
  </div>
</template>
<script>
import { linkifyPlainUrlsInHtml } from "./helpDeskHelpers.js";
import HelpDeskConversations from "./HelpDeskConversations.vue";
import TicketDetailsPanel from "./TicketDetailsPanel.vue";
import TicketViewHeader from "./TicketViewHeader.vue";
import CloseTicketDialog from "./CloseTicketDialog.vue";
import ManageengineUploadFiles from "./ManageengineUploadFiles.vue";
export default {
  metaInfo() {
    return {
      title: `Support Ticket #${this.$route.params.id} | Technician`,
    };
  },
  components: {
    TicketViewHeader,
    HelpDeskConversations,
    TicketDetailsPanel,
    CloseTicketDialog,
    ManageengineUploadFiles,
  },
  data: () => ({
    uploading: false,
    fileUploadList: [],
    loading: false,
    request: null,
    requester: null,
    processing: false,
    meUsername: null,
    replyDialog: false,
    replyDescription: "",
    oldTicket: false,
    closeTicketDialog: false,
    rules: {
      required: (value) => !!value || "Required.",
      email: (v) =>
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
          v
        ) || "Enter a valid email",
    },
  }),

  watch: {
    "$route.params.id": {
      immediate: false,
      async handler() {
        this.loading = true;
        await this.loadRequest();
      },
    },
  },

  async created() {
    await this.loadRequest();
  },
  methods: {
    async loadRequest() {
      try {
        const response = await this.$http.get(
          `api/manageengine/getRequestbyID?id=${this.$route.params.id}`
        );

        if (response.notFound) {
          this.$notify({
            text:
              "Ticket not found – it was probably deleted or merged with another request.",
            group: "notification",
            type: "error",
          });
          setTimeout(() => {
            this.$router.push("/helpdesk/requests");
          }, "500");
          return;
        }
        this.request = response.request;
        this.meUsername = response.username;
        this.loading = false;
        if (
          this.request.statusName == "Closed" &&
          Date.now() - 2.678e9 >
            new Date(this.request.lastUpdatedTime).getTime()
        ) {
          this.oldTicket = true;
        } else {
          this.oldTicket = false;
        }
      } catch (e) {
        setTimeout(() => {
          this.$router.push("/helpdesk/requests");
        }, "500");
      }
    },

    async reply() {
      try {
        this.processing = true;

        const filesId = [];
        for (var i = 0; i < this.fileUploadList.length; i++) {
          filesId.push(this.fileUploadList[i].file_id);
        }
        const sendFrom = this.$store.state.authentication.user.split("@")[0];

        const html = `<b>From: </b>${sendFrom}<hr />`;
        const description = linkifyPlainUrlsInHtml(this.replyDescription);
        await this.$http.post(`api/Manageengine/Reply`, {
          DisplayID: this.request.displayID,
          ManageengineID: this.request.manageengineID,
          Subject: `Re: [Request ID :##${this.request.displayID}##] : ${
            this.request.subject
          }`,
          Description: html + description,
          IsFromRequester: true,
          Attachments: filesId[0] ? JSON.stringify(filesId) : "",
        });

        this.$notify({
          text: "Comment added successfully",
          group: "notification",
          type: "success",
        });
        this.resetReplyDialog();
        await this.loadRequest();
        await this.$refs.conversations.updateConversationListAndNoteList();
      } catch (error) {
        this.$notify({
          text: "Error replying to ticket",
          group: "notification",
          type: "error",
        });
      }
    },

    resetReplyDialog() {
      this.replyDialog = false;
      this.processing = false;
      this.replyDescription = "";
      this.$refs.uploadFiles.reset();
    },
  },
};
</script>

<style>
.ticket-header-nav {
  background-color: #e8e8e8 !important;
  border: 1px solid #d5d5d5 !important;
  color: rgb(11, 160, 16) !important;
  min-width: 36px !important;
  width: 36px !important;
  height: 36px !important;
  padding: 0 !important;
  margin: 0 !important;
  border-radius: 6px !important;
  box-shadow: none !important;
  font-size: 14px !important;
  font-weight: 600 !important;
}

.reply-editor {
  border: 1px solid rgba(0, 0, 0, 0.42);
  border-radius: 4px;
  padding: 12px;
  min-height: 300px;
  font-size: 14px;
  line-height: 1.6;
  outline: none;
  overflow-y: auto;
}

.reply-editor:focus {
  border-color: #4caf50;
  border-width: 2px;
}
</style>
